import 'bootstrap/js/dist/modal';

export default () => {
  $('.modal').on({
    'show.bs.modal': (evt) => {
      const $modal = $(`#${evt.target.id}`);
      const video = $modal.find('video')[0];
      const event = document.createEvent('HTMLEvents');

      if (!video) return;

      setTimeout(() => {
        // Trigger resize event on video.
        // 300ms to match the fade transition time.
        event.initEvent('resize', true, false);
        video.dispatchEvent(event);
      }, 300);
    },

    'hide.bs.modal': (evt) => {
      const $modal = $(`#${evt.target.id}`);
      const video = $modal.find('video')[0];

      if (!video) return;

      if (!video.paused) video.pause();
    }
  });
};



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/modal.js